var _circle, _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPpidDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9993,
    cy: 27.4348,
    r: 27.4348,
    fill: "#E8F0F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1174 25.0234V38.5564C39.1174 39.441 38.766 40.2894 38.1405 40.9149C37.5149 41.5404 36.6665 41.8919 35.7819 41.8919H20.2163C19.3317 41.8919 18.4833 41.5404 17.8578 40.9149C17.2323 40.2894 16.8809 39.441 16.8809 38.5564V16.3199C16.8809 15.4352 17.2323 14.5868 17.8578 13.9613C18.4833 13.3358 19.3317 12.9844 20.2163 12.9844H27.0784C27.6679 12.9845 28.2333 13.2187 28.6502 13.6355L38.4663 23.4515C38.8831 23.8684 39.1173 24.4338 39.1174 25.0234Z",
    stroke: "#39A3D6",
    strokeWidth: 1.71468,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9986 13.5391V21.8778C27.9986 22.4675 28.2329 23.0331 28.6499 23.4501C29.0669 23.8671 29.6325 24.1014 30.2222 24.1014H38.5609M22.4395 29.6606H33.5577M22.4395 35.2197H33.5577",
    stroke: "#39A3D6",
    strokeWidth: 1.71468,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpidDoc);
export default __webpack_public_path__ + "static/media/ppid-doc.7ca9fb4099db07ccd543225d837f9c81.svg";
export { ForwardRef as ReactComponent };